import { useTranslation } from 'react-i18next';

import { IPersonMembershipItem } from '../../../../models/PersonMembershipItem';
import MembershipRelation from '../../../../styledComponents/MembershipRelation/MembershipRelation';
import { ProductTypeShortcut } from '../../../../models/enums/ProductTypeShortcut';
import {
  StyledOverviewProperty,
  SummaryWrapper,
} from '../../Common/MembershipSummary/membershipSummary.styles';

interface IDOCMembershipActiveSummaryProps {
  data: IPersonMembershipItem;
}

const DOCMembershipActiveSummary = ({
  data,
}: IDOCMembershipActiveSummaryProps) => {
  const { t } = useTranslation();
  return (
    <SummaryWrapper>
      <StyledOverviewProperty
        title={t('properties.product')}
        value={ProductTypeShortcut[data.productSubscription]}
        bold
        width="6rem"
      />
      <StyledOverviewProperty
        title={t('properties.package-type')}
        value={data.packageTypeName}
        width="12rem"
      />
      <StyledOverviewProperty
        title={t('properties.membership-relation')}
        width="6rem"
      >
        <MembershipRelation
          organizationName={data.organizationName}
          organizationId={data.organizationId}
          isRetail={data.isRetail}
        />
      </StyledOverviewProperty>
    </SummaryWrapper>
  );
};

export default DOCMembershipActiveSummary;
